import PropTypes from "prop-types";
import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { dateTimeToString } from "components/Shared/Formatters";

class QaRejectionList extends Component {
  constructor(props, context) {
    super(props, context);
    this.callOnRejectionClicked = this.callOnRejectionClicked.bind(this);
  }

  callOnRejectionClicked(rejection) {
    if (this.props.onRejectionClicked) {
      this.props.onRejectionClicked(rejection);
    }
  }

  render() {

    return (
      <>
        {this.props.viewOnly
          ? <div>Please see Case Actions to Respond</div>
          : <div />}
        <TableContainer component="div">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ maxWidth: 100, height: 30 }}>Date Created</TableCell>
                <TableCell style={{ width: "40%", minWidth: 250, maxWidth: 600, height: 30 }}>Reason</TableCell>
                <TableCell style={{ maxWidth: 100, height: 30 }}>Date Responded</TableCell>
                <TableCell style={{ width: "40%", minWidth: 250, maxWidth: 600, height: 30 }}>Response</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.qaAppraisalRejections.map((rejection) => (
                <TableRow key={rejection.id} onClick={() => { if (this.props.enabled) { this.callOnRejectionClicked(rejection); } }}>
                  <TableCell>{dateTimeToString(rejection.createdDate)}</TableCell>
                  <TableCell>{rejection.reasonNotes}</TableCell>
                  <TableCell>{dateTimeToString(rejection.responseDate)}</TableCell>
                  <TableCell>{rejection.responseNotes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }
}

QaRejectionList.propTypes = {
  enabled: PropTypes.bool.isRequired,
  qaAppraisalRejections: PropTypes.array.isRequired,
  onRejectionClicked: PropTypes.func,
  viewOnly: PropTypes.bool.isRequired,
};
export default QaRejectionList;